// src/App.js
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import ScrollToTop from "./components/ScrollToTop";
import { Analytics } from "@vercel/analytics/react";
import Admin from "./pages/admin";
import AdminSwarnaprashana from "./pages/AdminSwarnaprashana";
import AdminRoute from "./components/Admin/AdminRoute";
import AdminJournal from "./pages/AdminJournal";
import AdminJournalEditor from "./pages/AdminJournalEditor";
import Journal from "./pages/Journal";
import JournalArticle from "./pages/JournalArticle";
import AdminActivities from "./pages/AdminActivities";
import AdminActivityEditor from "./pages/AdminActivityEditor";
import ActivityDetail from "./pages/ActivityDetail";
import Activities from "./pages/Activities";


import { supabase } from "./lib/supabaseClient";

function AdminSessionGuard() {
  const location = useLocation();

  useEffect(() => {
    const isAdminRoute = location.pathname.startsWith("/admin");

    if (!isAdminRoute) {
      supabase.auth.signOut();
    }
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Analytics />

      <AdminSessionGuard />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/journal/:slug" element={<JournalArticle />} />
        <Route path="/activities/:slug" element={<ActivityDetail />} />
        <Route path="/activities" element={<Activities />} />
        

        <Route element={<AdminRoute />}>
          <Route
            path="/admin/swarnaprashana"
            element={<AdminSwarnaprashana />}
          />
          <Route
            path="/admin/journal"
            element={<AdminJournal />}
          />

          <Route
            path="/admin/journal/new"
            element={<AdminJournalEditor />}
          />

          <Route
            path="/admin/journal/edit/:id"
            element={<AdminJournalEditor />}
          />
          <Route
            path="/admin/activities"
            element={<AdminActivities />}
          />
          <Route
            path="/admin/activities/new"
            element={<AdminActivityEditor />}
          />

          <Route
            path="/admin/activities/edit/:id"
            element={<AdminActivityEditor />}
          />

        </Route>
      </Routes>
    </Router>
  );
}

export default App;